export const perPageOptions = [24, 36, 48];
